import { render, staticRenderFns } from "./BuyerDashboard.vue?vue&type=template&id=55435cf4&scoped=true"
import script from "./BuyerDashboard.vue?vue&type=script&lang=js"
export * from "./BuyerDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55435cf4",
  null
  
)

export default component.exports